<template>
  <div>
    <LoadingOverlay v-if="loading" />
    <div>
      <div id="view-sub-nav">
        <v-switch
          color="primary"
          :label="usInvoices ? 'US Invoices' : 'UK Invoices'"
          @update:model-value="
            () => {
              usInvoices = !usInvoices
            }
          "
          hide-details
        ></v-switch>
        <DateRangePicker class="ml-6" default="empty" :short="true" @change="dateRangeChanged"></DateRangePicker>
        <v-spacer></v-spacer>
        <v-btn
          class="ml-3"
          v-if="usInvoices"
          :disabled="this.selected.length !== 1"
          variant="outlined"
          color="primary"
          @click="generateSalesTax"
          >Generate Missing Sales Tax Data</v-btn
        >
        <v-btn
          class="ml-3"
          :disabled="this.selected.length !== 1"
          variant="outlined"
          color="primary"
          @click="singleInvoice"
          >Generate Invoice</v-btn
        >
        <v-btn
          class="ml-3"
          :disabled="this.selected.length !== 1"
          variant="outlined"
          color="primary"
          @click="deleteContactId"
          >Delete Contact ID</v-btn
        >
        <v-btn
          class="ml-3"
          :disabled="this.selected.length !== 1"
          variant="outlined"
          color="primary"
          @click="
            () => {
              addInvoiceDialog = true
              invoice = {}
            }
          "
          >Add Missing Invoice Data</v-btn
        >
      </div>
      <v-data-table
        v-model="selected"
        :items="usInvoices ? usMissingInvoices : ukMissingInvoices"
        :headers="usInvoices ? usHeaders : ukHeaders"
        select-strategy="single"
        show-select
        return-object
      >
        <template #item.id="{ item }">
          {{ item.id || '-' }}
        </template>
        <template #item.orderNumber="{ item }">
          {{ item.orderNumber || '-' }}
        </template>
        <template #item.type="{ item }">
          {{ item.type }}
        </template>
        <template #item.customerEmail="{ item }">
          {{ item.customerEmail || '-' }}
        </template>
        <template v-if="!usInvoices" #item.dateScheduled="{ item }">
          {{ $utils.convertDate(item.dateScheduled) || '-' }}
        </template>
        <template v-if="usInvoices" #item.dispatchEta="{ item }">
          {{ $utils.convertDate(item.dispatchEta) || '-' }}
        </template>
        <template #item.paidTotal="{ item }">
          {{ $numeral(item.paidTotal).format('0,0.00') || '-' }}
        </template>
        <template #item.orderTotal="{ item }">
          {{ $numeral(item.orderTotal).format('0,0.00') || '-' }}
        </template>
        <template v-if="usInvoices" #item.salesTax="{ item }">
          <div
            class="text-center"
            :class="item.salesTax == undefined ? 'text-red' : ''"
            :style="item.salesTax == undefined ? 'border: 2px solid red;' : ''"
          >
            {{ item.salesTax != undefined ? $numeral(item.salesTax).format('0,0.00') : 'Missing Tax' }}
          </div>
        </template>
        <template #item.balanceDue="{ item }">
          {{ item.balanceDue == 0 ? 'Paid' : $numeral(item.balanceDue).format('0,0.00') }}
        </template>
        <template #item.actions="{ item }">
          <v-tooltip location="top" :open-delay="500">
            <template v-slot:activator="{ props }">
              <v-icon size="small" @click="viewPayments(item)" v-bind="props" class="mr-2">mdi-cash-multiple</v-icon>
            </template>
            <span>View Payments</span>
          </v-tooltip>
          <v-tooltip location="top" :open-delay="500">
            <template v-slot:activator="{ props }">
              <v-icon size="small" @click="viewQuote(item)" v-bind="props">mdi-clipboard-text</v-icon>
            </template>
            <span>Original Quote</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>

    <div class="text-center">
      <v-snackbar color="bgGrey" v-model="responseSnackbar" vertical location="top" :timeout="-1">
        <div class="text-h6 pb-4">{{ responseMessage.message }}</div>
        <div v-if="responseMessage.xeroInvoiceID">
          <p class="text-body-1 font-weight-bold text-red">Please check xero links:</p>
          <p>Xero Invoice ID: {{ responseMessage.xeroInvoiceID }}</p>
          <p>Xero Invoice Number: {{ responseMessage.xeroInvoiceNumber }}</p>
          <p>
            Xero Invoice URL:
            <a class="mt-4 text-info" :href="responseMessage.xeroInvoiceURL" target="_blank">{{
              responseMessage.xeroInvoiceURL
            }}</a>
          </p>
        </div>
        <div v-else-if="responseMessage.error">
          <p class="text-body-1 font-weight-bold text-red">Error:</p>
          <p>{{ responseMessage.error }}</p>
        </div>

        <template v-slot:actions>
          <v-btn color="primary" variant="text" @click="responseSnackbar = false">Close</v-btn>
        </template>
      </v-snackbar>
    </div>

    <v-dialog v-model="addInvoiceDialog" width="800"
      ><v-card>
        <v-card-title>Add Invoice Data</v-card-title>
        <v-card-text>
          <v-text-field v-model="invoice.id" label="Xero Invoice ID (shown in title of preview)"></v-text-field>
          <v-text-field v-model="invoice.number" label="Xero Invoice Number (include 'INV-')"></v-text-field>
          <v-text-field v-model="invoice.url" label="Xero Invoice URL (under options, get link)"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="addInvoiceData">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="paymentsDialog" width="800">
      <v-card>
        <v-card-title>Payment Details</v-card-title>
        <v-card-text>
          <v-data-table :items="orderPayments" :headers="paymentHeaders" hide-default-footer :items-per-page="-1">
            <template #item.amount="{ item }">
              {{ $numeral(item.amount).format('0,0.00') }}
            </template>
            <template #item.date="{ item }">
              {{ item.date ? $utils.convertDate(item.date) : '-' }}
            </template>
            <template #item.chargeId="{ item }">
              {{ item.chargeId || '-' }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="paymentsDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Component Overlay Dialog -->
    <v-dialog v-model="quoteDialog" fullscreen transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar color="primary" class="no-print elevation-0">
          <v-toolbar-title>{{ dialogTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              () => {
                quoteDialog = false
                overlayComponent = null
              }
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <component
          :is="overlayComponent"
          :shipment="selectedOrder"
          :quoteID="selectedOrder.quoteID"
          :versionID="selectedOrder.versionID"
        ></component>
        <v-card-text> </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script type="text/javascript">
import QuoteEdit from '@/views/QuoteEdit'
import DateRangePicker from '@/components/ui/DateRangePicker'
import LoadingOverlay from '@/components/ui/LoadingOverlay'
import { db, functions } from '@/js/db'
import { collection, doc, getDoc, getDocs, query, setDoc, updateDoc, where } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'

export default {
  name: 'Invoicing',
  components: {
    QuoteEdit,
    DateRangePicker,
    LoadingOverlay
  },
  data() {
    return {
      activeDateRange: null,
      selected: [],
      loading: false,
      missingInvoices: [],
      ukHeaders: [
        {
          title: 'ID',
          sortable: false,
          key: 'id'
        },
        {
          title: 'Order #',
          sortable: false,
          key: 'orderNumber'
        },
        {
          title: 'Type',
          sortable: false,
          key: 'type'
        },
        {
          title: 'Customer Email',
          sortable: false,
          key: 'customerEmail'
        },
        {
          title: 'Date Scheduled',
          sortable: true,
          key: 'dateScheduled'
        },
        {
          title: 'Paid Total £',
          sortable: false,
          key: 'paidTotal'
        },
        {
          title: 'Order Total £',
          sortable: false,
          key: 'orderTotal'
        },
        {
          title: 'Balance Due £',
          sortable: false,
          key: 'balanceDue'
        },
        {
          title: 'Actions',
          sortable: false,
          align: 'end',
          width: 160,
          key: 'actions'
        }
      ],
      usHeaders: [
        {
          title: 'ID',
          sortable: false,
          key: 'id'
        },
        {
          title: 'Order #',
          sortable: false,
          key: 'orderNumber'
        },
        {
          title: 'Type',
          sortable: false,
          key: 'type'
        },
        {
          title: 'Customer Email',
          sortable: false,
          key: 'customerEmail'
        },
        {
          title: 'Dispatch ETA',
          sortable: true,
          key: 'dispatchEta'
        },
        {
          title: 'Paid Total $',
          sortable: false,
          key: 'paidTotal'
        },
        {
          title: 'Order Total $',
          sortable: false,
          key: 'orderTotal'
        },
        {
          title: 'Sales Tax $',
          sortable: false,
          key: 'salesTax'
        },
        {
          title: 'Balance Due $',
          sortable: false,
          key: 'balanceDue'
        },
        {
          title: 'Actions',
          sortable: false,
          align: 'end',
          width: 160,
          key: 'actions'
        }
      ],
      addInvoiceDialog: false,
      invoice: {},
      paymentsDialog: false,
      orderPayments: [],
      paymentHeaders: [
        {
          title: `Amount (${this.usInvoices ? '$' : '£'})`,
          sortable: false,
          key: 'amount'
        },
        {
          title: 'Date (DD/MM/YYYY)',
          sortable: false,
          key: 'date'
        },
        {
          title: 'Charge ID (ref)',
          sortable: false,
          key: 'chargeId'
        }
      ],
      usInvoices: false,
      selectedOrder: {},
      quoteDialog: false,
      dialogTitle: null,
      overlayComponent: null,
      responseSnackbar: false,
      responseMessage: {
        message: '',
        xeroInvoiceID: '',
        xeroInvoiceNumber: '',
        xeroInvoiceURL: ''
      }
    }
  },
  computed: {
    usMissingInvoices() {
      return this.missingInvoices.filter((order) => order.region === 'us' && this.usInvoices)
    },
    ukMissingInvoices() {
      return this.missingInvoices.filter((order) => order.region === 'uk' && !this.usInvoices)
    }
  },
  methods: {
    dateRangeChanged(range) {
      this.activeDateRange = range

      this.loadData()
    },
    // Every action starts here and ends in finishAction, so none of them can forget the reload.
    beginAction() {
      this.loading = true
      this.responseMessage = {
        message: '',
        xeroInvoiceID: '',
        xeroInvoiceNumber: '',
        xeroInvoiceURL: '',
        error: ''
      }
    },
    async finishAction() {
      await this.loadData()
      this.loading = false
      this.responseSnackbar = true
    },
    async loadData() {
      if (!this.activeDateRange) return

      this.loading = true
      this.selected = []
      this.missingInvoices = [] // resets the array on reload

      // set orderSnap depending on date range
      const orderSnap = await getDocs(
        query(
          collection(db, 'orders'),
          where('foc', '==', false),
          where('dateCreated', '>=', this.activeDateRange[0].startOf('day').toDate()),
          where('dateCreated', '<=', this.activeDateRange[1].endOf('day').toDate())
        )
      )

      for (const order of orderSnap.docs) {
        // check if paid for and doesnt have xero invoice
        if (order.data().payments.length > 0 && !order.data()?.xeroInvoiceNumber) {
          let orderObj
          // checking if its shipped/dispatched
          if (order.data().type === 'sample-pack') {
            if (order.data().dispatched) {
              orderObj = { ...order.data(), id: order.id }
              this.missingInvoices.push(orderObj)
              continue
            }
          } else if (order.data().type === 'mega-admin') {
            if (order.data().region === 'us') {
              if (order.data().shipped) {
                orderObj = { ...order.data(), id: order.id }
                this.missingInvoices.push(orderObj)
                continue
              }
            } else if (order.data().region === 'uk') {
              // uk shipped info is in shipment
              let shipped = true
              let dateScheduled
              const shipmentsSnap = await getDocs(query(collection(db, 'shipments'), where('orderID', '==', order.id)))
              for (const shipment of shipmentsSnap.docs) {
                if (shipment.data().shipped === false) shipped = false
                if (shipment.data().dateScheduled) {
                  dateScheduled = shipment.data().dateScheduled
                }
              }
              orderObj = { ...order.data(), dateScheduled, id: order.id }
              if (shipped) {
                this.missingInvoices.push(orderObj)
                continue
              } else {
                continue
              }
            }
          }
        }
      }

      // add cost/paid/balance info
      for (const orderObj of this.missingInvoices) {
        // order total
        orderObj.orderTotal = orderObj.total
        // add paid total
        let paidTotal = 0
        for (const payment of orderObj.payments) {
          paidTotal += payment.amount
        }
        orderObj.paidTotal = paidTotal

        // calc order total
        let taxToCollect = null

        if (orderObj.region === 'us') {
          // add sales tax
          const quoteSnap = await getDoc(doc(db, 'quotes', orderObj.quoteID))

          const version = quoteSnap.data().versions.find((version) => {
            return version.id === orderObj.versionID
          })
          if (version.pricing?.salesTax) {
            taxToCollect =
              typeof version.pricing.salesTax.amount_to_collect === 'number'
                ? version.pricing.salesTax.amount_to_collect
                : null
            orderObj.salesTax = taxToCollect !== null ? taxToCollect : version.pricing.salesTax.rate
          } else {
            orderObj.salesTax = undefined
          }

          const preTaxTotal = version.pricing?.total
          if (taxToCollect > 0 && typeof preTaxTotal === 'number') {
            orderObj.taxMissingFromTotal = Math.abs(orderObj.orderTotal - preTaxTotal) < 0.01
          }
        }

        // add balance due
        if (orderObj.balanceOutstanding) {
          const owed = orderObj.taxMissingFromTotal ? orderObj.orderTotal + taxToCollect : orderObj.orderTotal
          orderObj.balanceDue = this.$utils.toFixedNumber(owed - orderObj.paidTotal, 2)
        } else {
          orderObj.balanceDue = 0
        }
      }

      this.loading = false
    },

    async addInvoiceData() {
      this.addInvoiceDialog = false
      this.beginAction()
      const selectedOrder = await getDoc(doc(db, 'orders', this.selected[0].id))

      // check if there isnt already an xero link
      if (
        selectedOrder.data()?.xeroInvoiceNumber ||
        selectedOrder.data()?.xeroInvoiceID ||
        selectedOrder.data()?.xeroInvoiceURL
      ) {
        this.responseMessage.message = 'Invoice already exists'
        this.responseMessage.xeroInvoiceID = selectedOrder.data().xeroInvoiceID
        this.responseMessage.xeroInvoiceNumber = selectedOrder.data().xeroInvoiceNumber
        this.responseMessage.xeroInvoiceURL = selectedOrder.data().xeroInvoiceURL

        await this.finishAction()
      } else {
        this.invoice = {
          id: this.invoice.id,
          number: this.invoice.number,
          url: this.invoice.url
        }
        await updateDoc(doc(db, 'orders', this.selected[0].id), {
          xeroInvoiceID: this.invoice.id,
          xeroInvoiceNumber: this.invoice.number,
          xeroInvoiceURL: this.invoice.url
        })
        this.responseMessage.message = 'Invoice data added successfully'
        this.responseMessage.xeroInvoiceID = this.invoice.id
        this.responseMessage.xeroInvoiceNumber = this.invoice.number
        this.responseMessage.xeroInvoiceURL = this.invoice.url

        await this.finishAction()
      }
    },
    async singleInvoice() {
      this.beginAction()
      try {
        let orderId
        for (const order of this.selected) {
          orderId = order.id
        }
        const singleInvoiceFunc = httpsCallable(functions, 'manualSingleInvoice')
        const invoiceResult = await singleInvoiceFunc(orderId)
        if (invoiceResult && invoiceResult.data.xeroInvoiceID) {
          this.responseMessage.message = 'Invoices generated successfully'
          this.responseMessage.xeroInvoiceID = invoiceResult.data.xeroInvoiceID
          this.responseMessage.xeroInvoiceNumber = invoiceResult.data.xeroInvoiceNumber
          this.responseMessage.xeroInvoiceURL = invoiceResult.data.xeroInvoiceURL
        } else {
          this.responseMessage.message = 'Error generating invoices'
          this.responseMessage.error = invoiceResult.data.error
        }
      } catch (error) {
        console.log(error)
        this.responseMessage.message = 'Error generating invoices'
        this.responseMessage.error = error.message
      }
      await this.finishAction()
    },
    async deleteContactId() {
      this.beginAction()
      try {
        const selectedOrder = await getDoc(doc(db, 'orders', this.selected[0].id))
        let contactEmail = selectedOrder.data().customerEmail

        const userSnap = await getDocs(query(collection(db, 'users'), where('email', '==', contactEmail)))

        if (userSnap.docs.length > 0) {
          await updateDoc(userSnap.docs[0].ref, {
            xeroContactID: ''
          })
          this.responseMessage.message = 'Contact ID deleted successfully'
        }
      } catch (error) {
        this.responseMessage.message = 'Error deleting contact ID'
        this.responseMessage.error = error.message
      }
      await this.finishAction()
    },
    async generateSalesTax() {
      this.beginAction()
      try {
        const orders = this.selected.slice()

        for (const order of orders) {
          if (order.region === 'us') {
            const quoteRef = doc(db, 'quotes', order.quoteID)
            const quoteSnap = await getDoc(quoteRef)

            let quoteData = quoteSnap.data()

            const version = quoteData.versions.find((v) => {
              return v.id === order.versionID
            })

            if (!version.pricing?.salesTax) {
              version.pricing = {
                ...version.pricing,
                salesTax: {
                  rate: 0
                }
              }
            }

            await setDoc(quoteRef, quoteData)

            const calculateSalesTax = httpsCallable(functions, 'calculateSalesTax')
            const salesTax = await calculateSalesTax({
              to_zip: order.customerContactDetails.deliveryPostcode,
              to_state: order.customerContactDetails.deliveryState,
              to_city: order.customerContactDetails.deliveryCity,
              to_street: order.customerContactDetails.deliveryAddressLine1,
              amount: version.pricing.total - version.pricing.shipping,
              shipping: version.pricing.shipping,
              line_items: [
                {
                  id: '1',
                  quantity: 1,
                  unit_price: version.pricing.total - version.pricing.shipping,
                  discount: 0
                }
              ]
            })

            version.pricing.salesTax = salesTax.data

            await setDoc(quoteRef, quoteData)
          }
        }

        this.responseMessage.message = 'Sales tax data generated successfully'
        await this.finishAction()
        return true
      } catch (error) {
        this.responseMessage.message = 'Error generating sales tax data'
        this.responseMessage.error = error.message
        await this.finishAction()
        return false
      }
    },
    viewPayments(orderObj) {
      this.orderPayments = orderObj.payments.map((payment) => ({
        amount: payment.amount,
        date: payment.date,
        chargeId: payment.charge?.id || payment.balance_transaction?.source
      }))
      this.paymentsDialog = true
      return true
    },
    async viewQuote(orderObj) {
      if (this.usInvoices && orderObj.region == 'us') {
        const orderDoc = await getDoc(doc(db, 'orders', orderObj.id))

        this.quoteDialog = true
        this.selectedOrder = orderDoc.data()
        this.dialogTitle = orderDoc.data().customerEmail
        this.overlayComponent = 'QuoteEdit'
      } else if (!this.usInvoices && orderObj.region == 'uk') {
        const shipmentSnap = await getDocs(query(collection(db, 'shipments'), where('orderID', '==', orderObj.id)))

        this.quoteDialog = true
        this.selectedOrder = shipmentSnap.docs[0].data()
        this.dialogTitle = shipmentSnap.docs[0].data().customerEmail
        this.overlayComponent = 'QuoteEdit'
      }
      return true
    }
  }
}
</script>
